'use strict';

var _ = require('lodash');
var CurrentStateCriteriaService = function CurrentStateCriteriaService($rootScope, $q, Criteria, Rule, RsqlQuery, searchCriteriaConstantsService) {
  var criteria = new Criteria({});
  var isLoaded = $q.defer();
  $rootScope.$on('$stateChangeStart', function () {
    isLoaded.reject();
    isLoaded = $q.defer();
  });
  $rootScope.$on('$stateChangeCancel', function () {
    isLoaded.resolve();
  });
  function emptySearchCriteria() {
    criteria = new Criteria({});
  }
  function filterAndTransformCriteria(screen) {
    // filter out not applicable criteria
    if (screen === searchCriteriaConstantsService.FLIGHT_ANALYSIS) {
      criteria.filterOut(function (item) {
        return item.category === 'Post Departure';
      });
    } else {
      criteria.filterOut(function (item) {
        return item.level === 'Cabin' && item.field !== 'legs.legCabins.cabinCode' || item.level === 'Class' || item.field === 'custom:daysToDeparture:legs.departureDate';
      });
    }

    // transform custom fields
    criteria.rules = _.transform(criteria.rules, function (result, rule) {
      if (rule.field === 'legs.market') {
        rule.field = 'custom:leg';
      } else if (rule.field === 'custom:leg') {
        rule.field = 'legs.market';
      }
      rule.searchContext = screen;
      result.push(rule);
    }, []);

    // update context
    criteria = new Criteria(_.assign(criteria, {
      context: screen
    }));
  }
  function loadSearchCriteria(searchCriteria, customSearchMode, rsqlOverride) {
    criteria = new Criteria(searchCriteria);
    criteria.customSearchMode = criteria.customSearchMode || customSearchMode;
    criteria.rsqlOverride = rsqlOverride;
    isLoaded.resolve();
  }
  function handlePostDepartureModeChange(screen, customSearchMode) {
    filterAndTransformCriteria(screen);
    criteria.customSearchMode = customSearchMode;
    isLoaded.resolve();
  }
  function unchangedSearchCriteria(defaultSearchCriteria) {
    if (criteria.rules.length !== defaultSearchCriteria.rules.length) {
      return false;
    }
    for (var i = 0; i < criteria.rules.length; i++) {
      if (!criteria.rules[i].isEqual(defaultSearchCriteria.rules[i])) {
        return false;
      }
    }
    return true;
  }
  function addSearchCriteriaRule() {
    return criteria.addRule(new Rule({}));
  }
  function removeSearchCriteriaRule(index) {
    criteria.removeByIndex(index);
  }
  function isPostDeparture() {
    return criteria.customSearchMode === searchCriteriaConstantsService.SEARCH_MODES.POST_DEPARTURE;
  }
  function isLastSnapshotRecommendations() {
    return criteria.customSearchMode === searchCriteriaConstantsService.FO_SEARCH_MODES.RETRIEVE_LAST_SNAPSHOT;
  }
  function getCustomSearchMode() {
    return criteria.customSearchMode;
  }
  function getSearchCriteria() {
    return criteria;
  }
  function getRsqlOverride(mode) {
    if (_.isString(criteria.rsqlOverride)) {
      return criteria.rsqlOverride;
    }
    if (_.isObject(criteria.rsqlOverride)) {
      return criteria.rsqlOverride.getRsqlOverride(mode);
    }
    return undefined;
  }
  function clearRsqlOverrideSearch() {
    criteria.rsqlOverride = undefined;
  }
  function prepareForSaving() {
    return _.cloneDeep(criteria);
  }
  function isValid() {
    return criteria.isValid();
  }
  function getSearchCriteriaRulesForRsqlQuery() {
    var rsqlPromise = $q.defer();
    isLoaded.promise.then(function () {
      rsqlPromise.resolve(getSearchCriteria().rules);
    });
    return rsqlPromise.promise;
  }
  function copySearchCriteria(searchCriteria) {
    return new Criteria(searchCriteria);
  }
  function getCriteriaWithFlowType(flowType) {
    if (flowType === undefined) {
      throw 'flowType is not defined';
    }
    var currentCriteria = _.cloneDeep(criteria);
    currentCriteria.rules.push(new Rule({
      field: 'custom:flowType',
      operator: '=',
      leftOperand: flowType
    }));
    return currentCriteria;
  }
  function clearAlertSearch() {
    criteria.filterOut(function (item) {
      return item.field === 'pointOfSales.scorePerAlert.technicalId' || item.field === 'legs.legCabins.scorePerAlert.technicalId';
    });
  }
  return {
    loadSearchCriteria: loadSearchCriteria,
    unchangedSearchCriteria: unchangedSearchCriteria,
    addSearchCriteriaRule: addSearchCriteriaRule,
    removeSearchCriteriaRule: removeSearchCriteriaRule,
    clearAlertSearch: clearAlertSearch,
    clearRsqlOverrideSearch: clearRsqlOverrideSearch,
    getSearchCriteria: getSearchCriteria,
    getRsqlOverride: getRsqlOverride,
    prepareForSaving: prepareForSaving,
    getSearchCriteriaRulesForRsqlQuery: getSearchCriteriaRulesForRsqlQuery,
    isValid: isValid,
    emptySearchCriteria: emptySearchCriteria,
    isPostDeparture: isPostDeparture,
    getCustomSearchMode: getCustomSearchMode,
    copySearchCriteria: copySearchCriteria,
    getCriteriaWithFlowType: getCriteriaWithFlowType,
    handlePostDepartureModeChange: handlePostDepartureModeChange,
    isLastSnapshotRecommendations: isLastSnapshotRecommendations
  };
};
CurrentStateCriteriaService.$inject = ['$rootScope', '$q', 'SearchCriteriaFactory', 'SearchCriteriaRuleFactory', 'RsqlQueryFactory', 'SearchCriteriaConstantsService'];
module.exports = CurrentStateCriteriaService;